<template>
  <div id="bgMonMobPassWork">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>{{title_item}}</el-breadcrumb-item>
          <el-breadcrumb-item>收费月汇总报表</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             label-width="85px">
      <el-row>
      <el-col :span="24">
        <el-form-item label="客户名称::">
          <el-select v-model="selCustID"
                     filterable
                     clearable
                     @change="changeCust"
                     placeholder="请选择客户">
            <el-option v-for="item in choiceCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>
        <!--<el-form-item label="场库::">
          <el-select v-model="selParkID"
                     filterable
                     placeholder="请选择场库"
                     style="width:200px;"
                     clearable>
            <el-option v-for="item in park_list"
                       :key="item.fParkID"
                       :label="item.fParkName"
                       :value="item.fParkID">
            </el-option>
          </el-select>
        </el-form-item>-->
        <!--<el-form-item label=" " v-if="is_freevehicle">-->
        <el-form-item label=" " v-if="isfree">
          <el-checkbox v-model="isShow">免费放行车辆</el-checkbox>
        </el-form-item>
        <el-form-item label="年份::">
          <el-date-picker v-model="year"
                          style="width:100px"
                          type="year"
                          :clearable="false"
                          placeholder="选择年">
          </el-date-picker>
        </el-form-item>
        <!--<el-form-item label="起始日期::">
          <el-date-picker v-model="startTime"
                          style="width:140px"
                          type="date"
                          :clearable="false"
                          @change="selectStartMonth"
                          placeholder="选择起始日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期::">
          <el-date-picker v-model="endTime"
                          style="width:140px"
                          :clearable="false"
                          type="date"
                          @change="selectEndMonth"
                          placeholder="选择结束日期">
          </el-date-picker>
        </el-form-item>-->
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     :loading="loading"
                     @click="query">查询</el-button>
          <el-button type="success"
                     size="small"
                     icon="el-icon-share"
                     :loading="export_loading"
                     v-if="is_export"
                     @click="exportData">{{export_msg}}</el-button>
        </el-form-item>
      </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-table :data="dataList"
                border
                v-loading="loading"
                highlight-current-row
                style="width: 100%"
                :height="tableHeight"
                show-summary
                :summary-method="getSummaries"
                :row-class-name="tableRowClassName"
                stripe
                ref="singleTable">
        <el-table-column type="index" width="50"
                         label="序号" :index="indexMethod">
        </el-table-column>
        <el-table-column prop="fCustNo"
                         label="客户编号">
        </el-table-column>
        <el-table-column prop="fCustName"
                         label="客户名称">
        </el-table-column>
        <!--<el-table-column prop="fParkName"
                         label="场库名称">
        </el-table-column>-->
        <el-table-column prop="fPayDateTimeTitle"
                         label="日期">
        </el-table-column>
        <!--<el-table-column prop="fUserName"
                         label="操作员">
        </el-table-column>
        <el-table-column prop="fTotalSecsTitle"
                         align="right"
                         label="停车时长">
        </el-table-column>
        <el-table-column prop="fPaySecsTitle"
                         align="right"
                         label="计费时长">
        </el-table-column>-->
        <el-table-column prop="rowCounts"
                         align="right"
                         label="订单数量">
        </el-table-column>
        <el-table-column prop="fCalcAmtTitle"
                         align="right"
                         label="应收金额（元）">
        </el-table-column>
        <el-table-column prop="fFreePayAmtTitle"
                         align="right"
                         v-if="is_freevehicle&&isShow"
                         label="免费金额（元）">
        </el-table-column>
        <el-table-column prop="fScoreCouponTitle"
                        align="right"
                         label="积分优免（元）">
        </el-table-column>
        <el-table-column prop="fCDCouponTitle"
                        align="right"
                         label="充电优免（元）">
        </el-table-column>
        <el-table-column prop="fVipCouponTitle"
                        align="right"
                         label="卡券优免（元）">
        </el-table-column>
        <el-table-column prop="fOtherCouponTitle"
                        align="right"
                         label="其他优免（元）">
        </el-table-column>
        <el-table-column prop="fOnlinePayTitle"
                        align="right"
                         label="电子支付（元）">
        </el-table-column>
        <el-table-column prop="fCashPayTitle"
                         align="right"
                         label="现金支付（元）">
        </el-table-column>
        <el-table-column prop="fPayAmountTitle"
                         align="right"
                         label="实收金额（元）">
        </el-table-column>
        <el-table-column prop="fExpAmtTitle"
                         align="right"
                         label="差额（元）">
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { unionAPI as mobAPI } from '../../../api/unionReport'
import * as park from '../../../api/park'
import { mapActions } from 'vuex'
import * as user from '../../../api/user'
export default {
  name: 'bgMonMobPassWork.vue',
  data () {
    return {
      title_item: '缤谷广场定制报表',
      fUserNo: '',
      totalDes: '',
      is_export: false,
      isfree: false,
      is_freevehicle: false,
      carTypeList: [],
      selIsCard: '-1',
      year: 0,
      startTime: '',
      endTime: '',
      dataList: [],
      choiceCusts: [],
      payType_list: [],
      park_list: [],
      selCustID: '',
      selParkID: '',
      selPayTypeID: '',
      isShow: false,
      loading: false,
      export_loading: false,
      tableHeight: 0,
      pageSize: 20,
      pageNo: 1,
      total: 0,
      fPlateCode: '',
      isExpAmt: false,
      isException: false,
      isFreePayAmt: false,
      moneyTotal: {},
      export_msg: '导出'
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        Object.assign(this.$data, this.$options.data())
        this.init()
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'getCustByGroup'
    ]),
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 250
      obj.tableHeight = clientHeight
    },
    changeCust (fCustID) {
      this.selParkID = ''
      this.park_list = []
      if (fCustID) {
        // 加载场库
        park.getParkList({ fCustID: fCustID }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.park_list = data.Data || []
            } else {
              // this.$message.error('提示：加载场库列表失败')
            }
          }
        })
      }
    },
    query () {
      this.initData()
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.isRed === true) {
        return 'warning-row'
      }
      return ''
    },
    getCurrentMonthLast (dt) {
      var date = dt
      var currentMonth = date.getMonth()
      var nextMonth = ++currentMonth
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
      var oneDay = 1000 * 60 * 60 * 24
      var lastTime = new Date(nextMonthFirstDay - oneDay)
      var month = parseInt(lastTime.getMonth() + 1)
      var day = lastTime.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return new Date(date.getFullYear() + '-' + month + '-' + day + ' 23:59:59')
    },
    selectStartMonth () {
      var endMonth = this.endTime.getMonth()
      var startMonth = this.startTime.getMonth()
      if (endMonth !== startMonth) {
        this.endTime = this.getCurrentMonthLast(this.startTime)
      }
      this.endMonthOption = {
        disabledDate: (time) => {
          if (this.startTime !== '') {
            var endMonth = this.startTime.getMonth()
            var minMonth = time.getMonth()
            return time.getTime() < this.startTime.getTime() || minMonth !== endMonth
          }
        }
      }
    },
    selectEndMonth () {
      // var endMonth = this.endTime.getMonth()
      // var startMonth = this.startTime.getMonth()
      // if (endMonth !== startMonth) {
      //   var beginDay = this.endTime.getDate()
      //   this.startTime = new Date(this.endTime.getFullYear(), this.endTime.getMonth(), beginDay, 0, 0, 0)
      // }
      // this.startMonthOption = {
      //   disabledDate: (time) => {
      //     if (this.endTime !== '') {
      //       var endMonth = this.endTime.getMonth()
      //       var minMonth = time.getMonth()
      //       return time.getTime() > this.endTime.getTime() || endMonth > minMonth
      //     }
      //   }
      // }
    },
    initData () {
      this.dataList = []
      if ((this.selCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.loading = true
      var queryParam = {
        fCustID: this.selCustID,
        fUserNo: this.fUserNo,
        fParkID: this.selParkID,
        fPayTypeID: this.selPayTypeID,
        fYear: this.year.getFullYear(),
        fStartTime: this.$dateFormat(this.startTime, 'yyyy-MM-dd'),
        fEndTime: this.$dateFormat(this.endTime, 'yyyy-MM-dd'),
        fPlateCode: this.fPlateCode,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        exportData: 0,
        is_freevehicle: this.is_freevehicle,
        isShow: this.isShow
      }
      mobAPI.getBGGCMonPassWorkListAsync(queryParam).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.total = data.Data.total
              this.dataList = data.Data.rows
              this.moneyTotal = data.Data.moneyTotaldic
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    exportData () {
      if ((this.selCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.choiceCusts || []).filter((item) => {
        return item.fCustID === this.selCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      var queryParam = {
        fCustID: this.selCustID,
        fUserNo: this.fUserNo,
        fParkID: this.selParkID,
        fPayTypeID: this.selPayTypeID,
        fYear: this.year.getFullYear(),
        fStartTime: this.$dateFormat(this.startTime, 'yyyy-MM-dd'),
        fEndTime: this.$dateFormat(this.endTime, 'yyyy-MM-dd'),
        fPlateCode: this.fPlateCode,
        fIsCard: this.selIsCard,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        exportData: 1,
        is_freevehicle: this.is_freevehicle,
        isShow: this.isShow
      }
      mobAPI.getBGGCMonPassWorkListAsync(queryParam).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_收费月汇总报表.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    getSummaries (param) {
      var sums = []
      var index = 1
      for (let key in this.moneyTotal) {
        sums[index] = this.moneyTotal[key]
        index++
      }
      return sums
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    init () {
      var tmpPerTypeId = 1056000
      if (this.$route.query.type === '1') {
        this.title_item = '山钢和润旭辉里报表'
        tmpPerTypeId = 1156000
      }
      user.getCurrentUserPers({ perTypeId: tmpPerTypeId }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.is_export = data.Data.data.is_export
            }
          } else {
            this.$message.error('提示：加载当前用户权限信息失败')
          }
        }
      })
    }
  },
  created () {
    this.init()
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    var today = new Date()
    this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
    this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
    this.year = new Date()
    // this.carTypeList.push({'key': '-1', 'value': '全部(临时车+月卡车)'})
    // this.carTypeList.push({'key': '0', 'value': '临时车'})
    // this.carTypeList.push({'key': '1', 'value': '月卡车'})
    this.getCustByGroup().then(res => {
      if (res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            if (this.choiceCusts && this.choiceCusts.length === 1) {
              this.selCustID = this.choiceCusts[0].fCustID
              this.changeCust(this.selCustID)
            }
          }
        }
      }
    })
  },
  updated () {
    this.setTableHeight(this)
    this.$nextTick(() => {
      this.$refs['singleTable'].doLayout()
    })
  }
}
</script>

<style>
  #bgMonMobPassWork .warning-row {
    color: chocolate;
  }
  #bgMonMobPassWork .el-form-item {
    margin-bottom: 5px;
  }
  #bgMonMobPassWork .el-table{
    overflow:visible !important;
  }
</style>
<style scoped>
  .el-form-item {
    margin-bottom: 5px;
  }
  .pagination {
    text-align: right;
    padding-top: 5px;
  }
  .search {
    width: 200px;
  }
  .danger {
    color: #f56c6c;
  }
  .success {
    color: #67c23a;
  }
  .el-table{
    overflow:visible !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/report/unionReport/bgMonMobPassWork.vue